import { Fancybox } from '@fancyapps/ui'

Fancybox.bind(`[data-gallery="image-preview-gallery"]`, {
    groupAll: true,
    Toolbar: {
        display: {
            left: [],
            middle: [],
            right: ['close'],
        },
    },
    Thumbs: {
        type: 'classic',
    },
})
